import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { TranslocoLoader } from '@ngneat/transloco'
import { cs } from '../assets/i18n/cs'

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor() {}

  getTranslation(lang: string): Observable<any> {
    // For now, we'll return the TypeScript translations directly
    // In the future, you might want to load different language files dynamically
    return new Observable((subscriber) => {
      subscriber.next(cs)
      subscriber.complete()
    })
  }
}